import { CanDeactivateFn } from '@angular/router';
import { Observable, of, Subject } from 'rxjs';

export interface ModalUnsavedChanges {
  title: string;
  description: string;
  btnRightText?: string;
  btnLeftText?: string;
  width?: string;
  styleClass?: string;
}
export interface CanComponentUnsavedDeactivate {
  isEdit: () => boolean;
  hasPendingNavigationChanges?: () => boolean;
  modalUnsavedChanges?: ModalUnsavedChanges;
}

import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModalComponent } from '../components/common/dialog-modal/dialog-modal.component';
import { ButtonV2Type } from '../enum/common-enum';
import { ModalParam } from '../models/common-model';
import { TEXT_COMMON } from '../constants/text';
import { ProcessLoadingService } from '../services/loading.service';

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<CanComponentUnsavedDeactivate> {
  constructor(private dialogService: DialogService, private loadingService: ProcessLoadingService) {}

  canDeactivate(component: CanComponentUnsavedDeactivate): Observable<boolean> | boolean {


    if (!component.isEdit() && !component.hasPendingNavigationChanges?.()) {
          this.loadingService.showLoading();
    this.loadingService.hideLoading();
      return of(true); }
    this.loadingService.hideLoading();
    const subject = new Subject<boolean>();
    let confirmed = false;
    const componentModalParam = component.modalUnsavedChanges;
    const modalParam = new ModalParam();
    modalParam.description = componentModalParam?.description || TEXT_COMMON.UNSAVED_CHANGES;
    modalParam.title = componentModalParam?.title || TEXT_COMMON.CONFIRM;
    modalParam.iconUrl = 'images/icon/components/dialog/delete.svg';

    const btnRightText = componentModalParam?.btnRightText || TEXT_COMMON.STAY;
    const btnLeftText = componentModalParam?.btnLeftText || TEXT_COMMON.LEAVE;
    
    modalParam.buttonArray = [
      {
        buttonText: btnRightText,
        buttonType: ButtonV2Type.Outline,
        buttonStyle: { width: '120px' },
        clickFunction: () => { confirmed = false; }
      },
      {
        buttonText: btnLeftText,
        buttonType: ButtonV2Type.Solid,
        typecolor: 'red',
        buttonStyle: { width: '120px' },
        clickFunction: () => { confirmed = true; }
      }
    ];

    const ref = this.dialogService.open(DialogModalComponent, {
      header: modalParam.title,
      width: componentModalParam?.width ?? '30em',
      styleClass: componentModalParam?.styleClass,
      data: { modalParam }
    });

    ref.onClose.subscribe(() => {
      Promise.resolve().then(() => {
        subject.next(confirmed);
        subject.complete();
      });
    });

    return subject.asObservable();

    // if (component && typeof component.canDeactivate === 'function') {
    //   return component.canDeactivate();
    // }

    // return true;
  }
}
